import {AutowiredHttp} from 'utils/AutoWrite.js'
import { vhostUrl } from 'config/urlConfig.js'

@AutowiredHttp
class VhostService {
  constructor(){
    this.vueData = {}
    this.submitData = {}
  }
  // ajax请求(get)的中间层( 负责请求ajax和分发数据处理方法 并返回 )
  static async transformToVue(urlType, method, data){
    try {
      // ajax数据请求
      let queryUrl = vhostUrl[urlType]
      let queryData = data
      let ret = await VhostService.ajaxInstance.ajax(queryUrl, method, queryData)
      return {vueData: ret.data || {}, state: ret.state || {code:'000'}}
    }catch(err) {
      console.log( err )
    }
  }
  // ajax请求(put, post, delete)的中间层( 负责分发数据处理方法 并发送ajax )
  static async transformToService(urlType, method, data) {
    try {
      // ajax请求
      let queryUrl = vhostUrl[urlType]
      let queryData = data
      let ret = await VhostService.ajaxInstance.ajax(queryUrl, method, queryData)
      this.submitData = ret.data
      return {submitData: this.submitData, state: ret.state || {code:'000'}}
    }catch(err){
      console.log( err )
    }
  }
}
/**
 * 过滤XXXX数组里需要的数据
 * @param {Array} userArr 用户信息数组
 * @return {Array}  处理后的用户信息数组
 */

export default VhostService



// WEBPACK FOOTER //
// ./src/business/vhostService.js